import { useEffect, useReducer } from "react";

export const initialState = () => ({
  items: [],
  couponCode: '',
  idsForDelay: [],
  expandCoupons: false,
  couponApplied: false,
  expandDelayed: false,
  expandReferral: false,
  showInvalidCoupon: false,
  disableCouponLoading: false,
  taxRequestPending: false,
  referralApplied: false,
  zipCode: ''
});

export const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_ITEMS": {
      const { items } = payload;
      return {
        ...state,
        items
      };
    }
    case "SET_COUPON_CODE": {
      const { couponCode } = payload;
      return {
        ...state,
        couponCode
      };
    }
    case "SET_IDS_FOR_DELAY": {
      const { idsForDelay } = payload;
      return {
        ...state,
        idsForDelay
      };
    }
    case "SET_TAX_REQUEST_PENDING": {
      const { taxRequestPending } = payload;
      return {
        ...state,
        taxRequestPending
      };
    }
    case "SET_COUPON_LOADING": {
      const { disableCouponLoading } = payload;
      return {
        ...state,
        disableCouponLoading
      };
    }
    case "SET_ZIP_CODE": {
      const { zipCode } = payload;
      return {
        ...state,
        zipCode
      };
    }
    case "UPDATE_STATE": {
      return {
        ...state,
        ...payload
      };
    }
    default:
      return state;
  }
};

export function useCartReducer() {
  const [state, dispatch] = useReducer(reducer, initialState());
  return {
    state,
    dispatch
  };
}

export function useCrossSell(
  cart,
  setRevealedPricingIndices,
  handleCrossSellPriceSelection,
  crossSellsFor
) {
  useEffect(() => {
    [1, 2].forEach((tier, index) => {
      const primary = cart.mostRecentPrimaryCartItemAndAddons()[0];
      if (!primary) { return; }
      const banks = primary.product.crossSellsForTier(tier);
      banks.forEach((bank, subIndex) => {
        const bankId = bank?.id;
        // reveal cross sell pricing and select the product if it is already in the cart
        if (cart.includesAnyProduct(crossSellsFor(bank))) {
          setRevealedPricingIndices(prev => ({ ...prev, [index]: [...prev[index], subIndex] }));
        }
        crossSellsFor(bank).forEach((product) => {
          if (cart.includesAnyProduct([product])) {
            handleCrossSellPriceSelection(bankId, product);
          }
        });
      });
    });
  }, [cart, setRevealedPricingIndices, handleCrossSellPriceSelection, crossSellsFor]);
}
